module.exports = __webpack_public_path__ + "img/dfe63aa1d3937c20f7023fa23aa86e37.svg";